import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from "@app/interfaces";
import {Observable} from "rxjs";
import {DefectsStatus} from "@app/features/customers/defects/defects";

@Injectable({ providedIn: 'root' })

export class DefectsService extends InterfaceService {

    constructor(private http: HttpClient) {
        super();
    }

    addEditDefects(data: any) {
        return this.http.post(this.getApiUrl(`addEditDefect`), data);
    }

    getDefectsPipelineStages(pipelineId: string, payload: any) {
        return this.http.post(this.getApiUrl(`sales/getDefectsPipelineStages/${pipelineId}`), payload);
    }

    getDefectsByCustomer(customerId: string | number = 0, params = {}) {
        return this.http.post(this.getApiUrl(`sales/getDefectByCustomer/${customerId}`), params);
    }

    getDefectsByStages(pipelineId: string, params?: object) {
        return this.http.post(this.getApiUrl(`sales/getDefectsByStages/${pipelineId}`), params);
    }
    getDefectsPipelines(params?: object): Observable<any> {
        return this.http.get(this.getApiUrl(`getDefectsRecommendPipelines`, params));
    }

    addProposal(customerId: string, data: any): Observable<any> {
        return this.http.post(this.getApiUrl(`sales/addDefectsProposal/${customerId}`), data);
    }

    getDefectsRecommendationFilterFields(screenType: string) : Observable<any> {
        return this.http.get(this.getApiUrl(`sales/getDefectRecommendationFilter/${screenType}`))
    }

    updateDefectsStage(payload: any[]): Observable<any> {
        return this.http.post(this.getApiUrl(`sales/updateDefectsStage`), payload);
    }

    updateDefectsStatus(status: DefectsStatus, defectIds: any[]): Observable<any> {
        return this.http.post(this.getApiUrl(`sales/updateDefectsStatus`), {status, defectIds});
    }

    deleteDefect(id: string, pipelineId: any) {
        return this.http.delete(this.getApiUrl(`sales/deleteDefect/${id}?pipelineId=${pipelineId}`));
    }

    getDefectsPipelineAndStages(params: any) {
        return this.http.post(this.getApiUrl(`sales/getDefectsPipelineAndStages`), params);
    }

    saveSelectedView(data) {
        let url = this.getApiUrl(`userColumnOrder`)
        return this.http.post(url, data);
    }

    getDefectsRecommendation(): Observable<any> {
        return this.http.get(this.getApiUrl(`getDefectsRecommendation`));
    }

}
